import { Box, Typography } from '@mui/material';

const EmptyChart = ({
  height = { xs: 200, md: 220 },
  message = 'Nema podataka za prikaz.',
}) => (
  <Box
    sx={{
      height,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography sx={{ fontSize: 13, color: '#b0b0b0' }}>{message}</Typography>
  </Box>
);

export default EmptyChart;
